import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPatch, operationsClient } from '@/lib/api';
import { timeEntryEndpoints } from '@/lib/api/endpoints';
import { timeEntryKeys } from '@/lib/queryKeys';
import type { TimeEntry, UpdateTimeEntryDto } from '@/types/timeEntry';

export function useUpdateTimeEntry(appointmentId: string, jobId?: string) {
  const queryClient = useQueryClient();
  return useApiMutation<TimeEntry, { id: string; dto: UpdateTimeEntryDto }>({
    mutationFn: ({ id, dto }) =>
      apiPatch<TimeEntry, UpdateTimeEntryDto>(operationsClient, timeEntryEndpoints.update(id), dto),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: timeEntryKeys.appointment(appointmentId),
      });
      if (jobId) {
        void queryClient.invalidateQueries({ queryKey: timeEntryKeys.jobRollup(jobId) });
      }
      toast.success('Time entry updated');
    },
  });
}
